import Axios from '@/http'

export default {
  // 获取人脸检测详情
  getFaceRecogDetailApi(params) {
    return new Promise((resolve, reject) => {
      Axios.post('faceRecognition/detail', params).then((res) => {
        return resolve(res)
      })
    })
  }
}
